"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const contexts_1 = require("./contexts");
const Abattement_1 = __importDefault(require("./mecanisms/Abattement"));
const Applicable_1 = __importDefault(require("./mecanisms/Applicable"));
const Arrondi_1 = __importDefault(require("./mecanisms/Arrondi"));
const Bar_me_1 = __importDefault(require("./mecanisms/Bar\u00E8me"));
const common_1 = require("./mecanisms/common");
const Composantes_1 = __importDefault(require("./mecanisms/Composantes"));
const Dur_e_1 = __importDefault(require("./mecanisms/Dur\u00E9e"));
const Grille_1 = __importDefault(require("./mecanisms/Grille"));
const InversionNum_rique_1 = __importDefault(require("./mecanisms/InversionNum\u00E9rique"));
const Maximum_1 = __importDefault(require("./mecanisms/Maximum"));
const Minimum_1 = __importDefault(require("./mecanisms/Minimum"));
const NonApplicable_1 = __importDefault(require("./mecanisms/NonApplicable"));
const Operation_1 = __importDefault(require("./mecanisms/Operation"));
const ParD_faut_1 = __importDefault(require("./mecanisms/ParD\u00E9faut"));
const Plafond_1 = __importDefault(require("./mecanisms/Plafond"));
const Plancher_1 = __importDefault(require("./mecanisms/Plancher"));
const Product_1 = __importDefault(require("./mecanisms/Product"));
const Recalcul_1 = __importDefault(require("./mecanisms/Recalcul"));
const Replacement_1 = __importDefault(require("./mecanisms/Replacement"));
const ReplacementRule_1 = __importDefault(require("./mecanisms/ReplacementRule"));
const Rule_1 = __importDefault(require("./mecanisms/Rule"));
const R_soudreR_f_renceCirculaire_1 = __importDefault(require("./mecanisms/R\u00E9soudreR\u00E9f\u00E9renceCirculaire"));
const Situation_1 = __importDefault(require("./mecanisms/Situation"));
const Somme_1 = __importDefault(require("./mecanisms/Somme"));
const Synchronisation_1 = __importDefault(require("./mecanisms/Synchronisation"));
const TauxProgressif_1 = __importDefault(require("./mecanisms/TauxProgressif"));
const ToutesCesConditions_1 = __importDefault(require("./mecanisms/ToutesCesConditions"));
const UneDeCesConditions_1 = __importDefault(require("./mecanisms/UneDeCesConditions"));
const UnePossibilit_1 = __importDefault(require("./mecanisms/UnePossibilit\u00E9"));
const Unit_1 = __importDefault(require("./mecanisms/Unit\u00E9"));
const Variations_1 = __importDefault(require("./mecanisms/Variations"));
const UIComponents = {
    constant: common_1.ConstantNode,
    abattement: Abattement_1.default,
    'applicable si': Applicable_1.default,
    arrondi: Arrondi_1.default,
    barème: Bar_me_1.default,
    composantes: Composantes_1.default,
    durée: Dur_e_1.default,
    grille: Grille_1.default,
    inversion: InversionNum_rique_1.default,
    maximum: Maximum_1.default,
    minimum: Minimum_1.default,
    'non applicable si': NonApplicable_1.default,
    operation: Operation_1.default,
    'par défaut': ParD_faut_1.default,
    plafond: Plafond_1.default,
    plancher: Plancher_1.default,
    produit: Product_1.default,
    reference: common_1.Leaf,
    rule: Rule_1.default,
    'nom dans la situation': Situation_1.default,
    somme: Somme_1.default,
    synchronisation: Synchronisation_1.default,
    recalcul: Recalcul_1.default,
    replacement: Replacement_1.default,
    replacementRule: ReplacementRule_1.default,
    'taux progressif': TauxProgressif_1.default,
    'toutes ces conditions': ToutesCesConditions_1.default,
    'une de ces conditions': UneDeCesConditions_1.default,
    'une possibilité': UnePossibilit_1.default,
    'résoudre référence circulaire': R_soudreR_f_renceCirculaire_1.default,
    unité: Unit_1.default,
    'variable temporelle': () => '[variable temporelle]',
    variations: Variations_1.default,
};
function Explanation({ node }) {
    const visualisationKind = node.visualisationKind || node.nodeKind;
    const engine = react_1.useContext(contexts_1.EngineContext);
    if (!engine) {
        throw new Error('We need an engine instance in the React context');
    }
    // On ne veut pas (pour l'instant) déclencher une évaluation juste pour
    // l'affichage.
    // A voir si cela doit évoluer...
    const displayedNode = node.evaluationId ? engine.evaluate(node) : node;
    const Component = UIComponents[visualisationKind];
    if (!Component) {
        throw new Error(`Unknown visualisation: ${visualisationKind}`);
    }
    return jsx_runtime_1.jsx(Component, Object.assign({}, displayedNode), void 0);
}
exports.default = Explanation;
